import { selectStyles } from '../Select';
export const contextMenuStyles = {
    ...selectStyles,
};
